import template from "./contact-modal.html";
import countriesTranslations from "../../../../common/translations/countries";
import { uniqBy } from "lodash";

const ContactModalComponent = {
  bindings: {
    close: "&",
    dismiss: "&",
    resolve: "<",
  },
  template: template,
  controller: class ContactModalController {
    /* @ngInject */
    constructor($filter, Contact, Notification, $rootScope, countries, Utils) {
      this.$filter = $filter;
      this.Contact = Contact;
      this.NotificationService = Notification;
      this.$rootScope = $rootScope;
      this.countries = countries;
      this.countryFilter = Utils.filterDiacriticsInsensitive(
        countriesTranslations,
        $rootScope.organization.settings.appLanguage,
      );
    }

    $onInit() {
      this.editMode = this.resolve.editMode;
      this.contact = new this.Contact(this.resolve.contact);
      this.contactEmailIsNotUnique = false;
      if (!this.contact.currency) this.setCurrency(this.$rootScope.organization.settings.currency);
      this.openedMoreData = true;
      this.saving = false;

      this.$rootScope.$watch(
        () => this.contact.email,
        (newVal, oldVal) => {
          if (this.contactEmailIsNotUnique) this.contactEmailIsNotUnique = false;
        },
      );
    }

    setCurrency(oldCurrency, newCurrency) {
      if (!newCurrency) this.contact.currency = oldCurrency;
      else this.contact.currency = newCurrency;
    }

    showMoreData() {
      this.openedMoreData = !this.openedMoreData;
    }

    async searchContacts(searchText) {
      const searchedContacts = await this.Contact.query({
        q: searchText,
        onlyByCompany: true,
      });
      return uniqBy(searchedContacts, "company");
    }

    setContactCompany(contactSearched) {
      this.contact.company = contactSearched.company;
    }

    async save() {
      if (!this.form.$valid) return;

      this.saving = true;
      try {
        await this.contact.save();
        this.NotificationService.success({
          title: this.$filter("trans")("notificationService.title.success"),
          message: this.$filter("trans")("notificationService.message.saveContact"),
        });
        this.close({ $value: this.contact });
      } catch (e) {
        if (e.data === "Contact email already exist") {
          this.contactEmailIsNotUnique = true;
        }
      }
      this.saving = false;
      this.$rootScope.$applyAsync();
    }
  },
};

export default ContactModalComponent;
